module.exports = __webpack_public_path__ + "img/content-new-6.dc9343b.png";